import React from "react";
import { Field } from "react-final-form";

export const Condition = ( { when, is, itIncludes, children } ) => {
    return <Field name={ when } subscription={ { value: true } }>
        { is ?
            ( { input: { value } } ) => (value === is ? children : null)
            :
            ( { input: { value } } ) => (value.includes( itIncludes ) ? children : null)
        }
    </Field>
}